const getEdges = (data) => data?.allMarkdownRemark?.edges
export { getEdges }
